import { render, staticRenderFns } from "./BaseAssignation.vue?vue&type=template&id=25dec24e"
import script from "./BaseAssignation.vue?vue&type=script&lang=js"
export * from "./BaseAssignation.vue?vue&type=script&lang=js"
import style0 from "./BaseAssignation.vue?vue&type=style&index=0&id=25dec24e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports